// ----------------------------------------------------------------------

export default function Pickers(theme) {
  return {}
}
